/** Viewport width (px) at/above which the desktop UI is shown. */
export const MOBILE_BREAKPOINT = 768;
